export default "__VITE_ASSET__C8DEptB5__"